export const ELIGIBLE_MARKETS = {
  // keys must be lower case
  us: true
};
export const TYPE_CREDO_OPT_IN = 'CREDO_OPT_IN';
export const DEFAULT_FEATURE = 'credo';
export const CREDO_RAMPUP_FEATURE = 'credo_rampup';
export const NOT_RAMPED_UP_VARIANT = 'not-ramped-up';
export const RAMPED_UP_VARIANT = 'ramped-up';
export const ALLOW_LIST_VARIANT = 'allow-list';

/** @deprecated The welcome bar has been removed */
export const TYPE_CREDO_WELCOME_BAR_DISMISSED = 'CREDO_WELCOME_BAR_DISMISSED';
/** @deprecated The loyalty experiment has been concluded */
export const CREDO_LOYALTY_FEATURE = 'credo_loyalty';